const SubAbas = [{ label: 'Gestão MedSUS', rota: '/secsaude/medsus/gestao' }];

const SubAbasMedusDaf = (id: string) => [
  {
    label: 'Dados Gerais',
    rota: `/daf/produtosdaf/medsus/${id}/dadosgerais`,
  },
];

export { SubAbas, SubAbasMedusDaf };
